module.exports = __webpack_public_path__ + "static/img/iphone-pinzheng.aee0c76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/download/iphone-pinzheng.png
// module id = Mu3i
// module chunks = 69